export default __webpack_public_path__ + "static/media/manejo_dolor_sala_emergencias.3dad3066.pdf";